import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje/sonia")({
  head: () => ({
    meta: [
      { title: "SonIA | Tecnología de Aprendizaje | Mine Class" },
      {
        name: "description",
        content:
          "SonIA: relatora virtual impulsada por IA con avatares, voces y acentos personalizables para escalar contenidos de formación.",
      },
      { property: "og:title", content: "SonIA | Mine Class" },
      { property: "og:description", content: "Relatora virtual con IA: avatares, voces y acentos personalizables para escalar contenidos de formación minera." },
      { property: "og:url", content: "https://mine-class.com/soluciones/tecnologia-aprendizaje/sonia" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/tecnologia-aprendizaje/sonia" }],
  }),
  component: SoniaContent,
});

function SoniaContent() {
  return (
    <article className="space-y-6 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          Relatora virtual con IA
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">SonIA</h2>
      </div>

      <p>
        Relatora virtual impulsada íntegramente por inteligencia artificial. SonIA transforma contenidos
        técnicos en experiencias de aprendizaje más dinámicas, atractivas y escalables. Su avatar es
        completamente personalizable —apariencia, voz, acento y más— para adaptar cada relatoría a la
        identidad de la organización y a las preferencias de su audiencia.
      </p>
      <p>
        Con soporte multi-idioma, SonIA amplía el alcance de las capacitaciones y aumenta
        significativamente el engagement de los estudiantes. Su capacidad de actualizar contenidos de
        forma instantánea asegura que el material esté siempre vigente.
      </p>
      <p>
        Habilita la generación de contenido de manera masiva, escalable y a bajo costo, permitiendo
        producir cursos y materiales educativos en una fracción del tiempo habitual.
      </p>

      <div className="flex flex-wrap gap-2 pt-2">
        {["Avatares custom", "Multi-idioma", "Voz & acento", "Bajo costo"].map((f) => (
          <span
            key={f}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--color-brand-coral)]/10 text-[var(--color-brand-coral)] text-[11px] font-semibold"
          >
            <span className="material-symbols-outlined text-[13px]">check</span>
            {f}
          </span>
        ))}
      </div>

      <div className="pt-4">
        <Link
          to="/contacto"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Ver Demostración
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </Link>
      </div>
    </article>
  );
}
